var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVuejs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 262.998,
    height: 227.765,
    viewBox: "0 0 262.998 227.765",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuejs",
    transform: "translate(-76.306 313.339)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3285",
    "data-name": "Group 3285",
    transform: "translate(76.306 -313.339)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55059",
    "data-name": "Path 55059",
    d: "M.766,0-29.6,52.6-59.971,0H-161.1L-29.6,227.765,101.9,0Z",
    transform: "translate(161.101)",
    fill: "#41b883"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3286",
    "data-name": "Group 3286",
    transform: "translate(128.906 -313.339)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55060",
    "data-name": "Path 55060",
    d: "M.517,0-29.851,52.6-60.22,0h-48.531l78.9,136.657L49.048,0Z",
    transform: "translate(108.751)",
    fill: "#34495e"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuejs);
export default __webpack_public_path__ + "static/media/vuejs.0d44653f703584f8628e97c98196fd71.svg";
export { ForwardRef as ReactComponent };